import * as yup from "yup";

const AddAndChangeSchema = (translate: Function) => yup.object().shape({
	ofm002Descricao: yup.string().required(translate("Descrição é requerido")),
	ofm002Formula: yup.string().when("ofm002Origem", {
		is: "90" || 90,
		then: yup.string().required(translate("Fórmula é requerido"))
	})
});

export default AddAndChangeSchema;
